import { CancelFlowProvider } from '../CancelDialog/context/CancelFlowContext';
import { RescheduleFlowProvider } from '../RescheduleDialog/context/RescheduleFlowContext';

interface ManageSessionProviderProps {
  children: React.ReactNode;
}

export const ManageSessionProvider = ({ children }: ManageSessionProviderProps) => (
  <RescheduleFlowProvider>
    <CancelFlowProvider>{children}</CancelFlowProvider>
  </RescheduleFlowProvider>
);
